import { render, staticRenderFns } from "./NomenclatureDropdown.vue?vue&type=template&id=3a441080&"
import script from "./NomenclatureDropdown.vue?vue&type=script&lang=js&"
export * from "./NomenclatureDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports